import { fetchSilicie } from "../../../services/Aeat.jsx";
import { downloadBlob } from "../../../utils/download.js";
import Button from "./Button.jsx";

const SilicieButton = ({ receipts, children }) => {
  const handleDownload = async (e) => {
    e.preventDefault();
    try {
      const receiptIds = { receipts: receipts.map(obj => obj.id) };
      const blob = await fetchSilicie(receiptIds);
      downloadBlob(blob, "silicie.csv");
    } catch (err) {
      console.error("Error completo:", err);
      alert(
        `No se pudo descargar el CSV:\n`
          + `${err.response?.status || ""} ${err.response?.statusText || err.message}`,
      );
    }
  };
  return <Button onClick={handleDownload}>{children}</Button>;
};

export default SilicieButton;
